import React from 'react'
import { styles } from './styles'
import { makeStyles } from '@material-ui/styles'

export const OrSeparate = () => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  return (
    <div className={classes.orContainer}>
      <span className={classes.orLine} />
      <span className={classes.orText}>OR</span>
      <span className={classes.orLine} />
    </div>
  )
}
